import { FC } from 'react';
import styles from './CoverSticker.module.scss';

interface ICoverSticker {
  name: string;
  extraClassName?: string;
}

const CoverSticker: FC<ICoverSticker> = ({ name, extraClassName }) => {
  return <span className={extraClassName ? `${styles.coverSticker} ${styles[`${extraClassName}`]}` : `${styles.coverSticker}`}>{name}</span>;
};
export default CoverSticker;
